import { CoreMenu } from '@core/types';
import { RoleType } from 'app/server/enums/role-type';

export const schoolMenu: CoreMenu[] = [
	{
		id: 'home',
		title: 'Dashboard',
		translate: 'menu_school_home',
		type: 'item',
		icon: 'home',
		url: 'university/school/home',
	},
	{
		id: 'coorti',
		title: 'Coorti',
		translate: 'menu_school_cohorts',
		type: 'item',
		icon: 'users-rectangle',
		url: 'university/school/cohorts',
		permissions: ['school_cohorts.view'],
	},
	{
		id: 'statistics',
		title: 'Statistiche',
		translate: 'menu_statistics',
		type: 'item',
		icon: 'chart-column',
		url: 'university/school/statistics',
		permissions: ['reports.view'],
	},
	// {
	// 	id: 'unità operative',
	// 	title: 'Unità Operative',
	// 	translate: 'menu_school_operational_units',
	// 	type: 'item',
	// 	icon: 'hospital',
	// 	url: 'university/school/operational-units',
	// },
	{
		id: 'programmi didattici',
		title: 'Programmi Didattici',
		translate: 'menu_school_didactic_programs',
		type: 'item',
		icon: 'chalkboard-user',
		url: 'university/school/didactic-programs',
		permissions: ['school_didactic_programs.view'],
	},

	// Attività
	{
		id: 'activities',
		title: 'Attività',
		translate: 'menu_school_activities_section',
		type: 'collapsible',
		icon: 'book',
		children: [
			{
				id: 'activities',
				title: 'Attività pratiche e di tirocinio (professionalizzanti)',
				translate: 'menu_school_activities',
				type: 'item',
				url: 'university/school/activities',
				permissions: ['school_activities.view'],
			},
			{
				id: 'lessons',
				title: 'Didattica frontale (non professionalizzanti - lezioni pratiche)',
				translate: 'menu_school_lessons',
				type: 'item',
				url: 'university/school/lessons',
				permissions: ['school_lessons.view'],
			},
			{
				id: 'formal-teachings',
				title: 'Didattica Formale',
				translate: 'menu_school_formal_teachings',
				type: 'item',
				url: 'university/school/formal-teachings',
				permissions: ['school_formal_teachings.view'],
			},
		],
	},

	// Utenti
	{
		id: 'users',
		title: 'Utenti',
		translate: 'menu_school_users',
		type: 'item',
		icon: 'users',
		url: 'university/school/users',
		permissions: ['school_users.view'],
	},

	// Obiettivi
	{
		id: 'totalizers',
		title: 'Obiettivi',
		translate: 'menu_school_totalizers_section',
		type: 'collapsible',
		icon: 'bullseye',
		children: [
			{
				id: 'totalizers',
				title: 'Obiettivi',
				translate: 'menu_school_totalizers_section',
				type: 'item',
				url: 'university/school/totalizers',
				permissions: ['school_totalizers.view'],
			},
			{
				id: 'school-totalizer',
				title: 'Obiettivi Programmi Didattici',
				translate: 'menu_school_didactic_programs_totalizers',
				type: 'item',
				url: 'university/school/didactic-programs-totalizers',
				permissions: ['school_didactic_programs_totalizers.view'],
			},
			{
				id: 'activities-totalizers',
				title: 'Obiettivi Attività Professionalizzanti',
				translate: 'menu_school_activities_totalizers',
				type: 'item',
				url: 'university/school/activities-totalizers',
				permissions: ['school_activities_totalizers.view'],
			},
		],
	},

	// Convenzioni
	{
		id: 'agreements',
		title: 'Convenzioni',
		translate: 'menu_school_agreements',
		type: 'item',
		url: 'university/school/agreements',
		icon: 'file-contract',
		permissions: ['school_agreements.view'],
	},

	// Turni
	{
		id: 'shifts',
		title: 'Turni',
		translate: 'menu_school_shifts',
		type: 'item',
		url: 'university/school/shifts',
		icon: 'clock',
		permissions: ['school_shifts.view'],
	},

	// Rotazioni
	{
		id: 'rotations',
		title: 'Rotazioni',
		translate: 'menu_school_rotations',
		type: 'item',
		url: 'university/school/rotations',
		icon: 'rotate',
		permissions: ['school_rotations.view'],
	},

	// Carriere
	{
		id: 'careers',
		title: 'Carriere',
		translate: 'menu_school_careers',
		type: 'item',
		url: 'university/school/careers',
		icon: 'briefcase',
		permissions: ['school_careers.view'],
	},

	// Sospensive
	{
		id: 'suspensions',
		title: 'Sospensive',
		translate: 'menu_school_suspensions',
		type: 'item',
		url: 'university/school/suspensions',
		icon: 'ban',
		permissions: ['school_suspensions.view'],
	},
	// Ruoli degli utenti della scuola (#17531): la stessa pagina del multi-tenant, solo SuperAdmin, filtrata sugli
	// utenti con un profilo nella scuola. "Gestione Ruoli" resta solo nel multi-tenant perché i ruoli sono globali
	{
		id: 'school-admin-users',
		title: 'Gestione Ruoli Utenti',
		translate: 'menu_admin_users',
		type: 'item',
		icon: 'user-shield',
		url: 'university/school/admin/users',
		roles: [RoleType.SuperAdmin],
		permissions: ['admin_users.view'],
	},
	// Report (come nel multi-tenant; "I miei Report" è già filtrato sulla scuola corrente, la coda solo per il SuperAdmin)
	{
		id: 'reports-section',
		title: 'Report',
		translate: 'menu_reports_section',
		type: 'collapsible',
		icon: 'file-alt',
		children: [
			{
				id: 'my-reports',
				title: 'I miei Report',
				translate: 'menu_my_reports',
				type: 'item',
				url: 'university/school/my-reports',
				permissions: ['reports.view'],
			},
			{
				id: 'admin-reports-queue',
				title: 'Coda Report',
				translate: 'menu_admin_reports_queue',
				type: 'item',
				url: 'university/school/reports-queue',
				roles: [RoleType.SuperAdmin],
				permissions: ['admin_reports.view'],
			},
		],
	},
];
